import { Directive, ElementRef, Input, NgZone, OnChanges, Renderer2, SimpleChanges, inject } from '@angular/core';

@Directive({
  selector: '[zeroBlink]',
  standalone: true,
})
export class BlinkDirective implements OnChanges {
  @Input() public zeroBlink: boolean | string;
  @Input() public val: number;

  #timerbg: NodeJS.Timeout;
  #timerarrow: NodeJS.Timeout;
  #blinkbg = false;
  #blinkarrow = true;

  readonly #renderer = inject(Renderer2);
  readonly #el = inject(ElementRef);
  readonly #ngZone = inject(NgZone);

  constructor() {
    if (this.zeroBlink === false) {
      return;
    }

    if (this.#blinkbg) {
      this.#renderer.addClass(this.#el.nativeElement, 'blink');
    } else if (this.#blinkarrow) {
      this.#renderer.addClass(this.#el.nativeElement, 'quoteindicator');
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.zeroBlink === false) {
      return;
    }

    if (this.#blinkbg) {
      this.#ngZone.runOutsideAngular(() => {
        this.#updateBlinkBg(changes);
      });
    } else if (this.#blinkarrow) {
      this.#ngZone.runOutsideAngular(() => {
        this.#updateBlinkArrow(changes);
      });
    }
  }

  #updateBlinkBg(changes: SimpleChanges): void {
    this.#renderer.removeClass(this.#el.nativeElement, 'blink--green');
    this.#renderer.removeClass(this.#el.nativeElement, 'blink--red');

    let className;
    if (changes['val'].currentValue > changes['val'].previousValue) {
      className = 'blink--green';
    } else if (changes['val'].currentValue < changes['val'].previousValue) {
      className = 'blink--red';
    }

    if (this.#timerbg) {
      clearTimeout(this.#timerbg);
    }

    if (className) {
      this.#renderer.addClass(this.#el.nativeElement, className);
      this.#timerbg = setTimeout(() => {
        this.#renderer.removeClass(this.#el.nativeElement, className);
      }, 100);
    }
  }

  #updateBlinkArrow(changes: SimpleChanges): void {
    this.#renderer.removeClass(this.#el.nativeElement, 'quoteindicator--up');
    this.#renderer.removeClass(this.#el.nativeElement, 'quoteindicator--down');

    let className: string;
    if (changes['val']) {
      if (changes['val'].currentValue > changes['val'].previousValue) {
        className = 'quoteindicator--up';
      } else if (changes['val'].currentValue < changes['val'].previousValue) {
        className = 'quoteindicator--down';
      }
    }

    if (this.#timerarrow) {
      clearTimeout(this.#timerarrow);
    }

    if (className) {
      this.#renderer.addClass(this.#el.nativeElement, className);
      this.#renderer.addClass(this.#el.nativeElement, 'quoteindicator--show');
      this.#timerarrow = setTimeout(() => {
        this.#renderer.removeClass(this.#el.nativeElement, 'quoteindicator--show');
      }, 500);
    }
  }
}
